import axios from "axios";
import { BASE_URL } from "../../_constants/urlConstants";
import { getUUID } from "../../_utils/generalUtils";
import raiseError from "../raiseError";
import qs from "qs";
import { QMS } from "../../_constants/actionConstants";

const logError = (e) => console.error("ProDMS/QMS: Request failed with error:", e);

const qmsTeamActions = {
  add: (newTeamData) => async (dispatch) => {
    dispatch({ type: QMS.TEAM.ADD });
    const apiEndpoint = BASE_URL + "/api/qms/QmsTeam";
    try {
      const res = await axios.post(apiEndpoint, newTeamData);
      dispatch({ type: QMS.TEAM.ADD_FULFILLED });
      return res.data;
    } catch (e) {
      dispatch({ type: QMS.TEAM.ADD_REJECTED });
      logError(e);
    }
  },
  update: (qmsTeamData) => async (dispatch) => {
    dispatch({ type: QMS.TEAM.UPDATE });
    const apiEndpoint = BASE_URL + "/api/qms/QmsTeam";
    try {
      const res = await axios.put(apiEndpoint, qmsTeamData);
      dispatch({
        type: QMS.TEAM.UPDATE_FULFILLED,
        divisionId: qmsTeamData.divisionId,
        qmsTeams: res.data,
      });
    } catch (e) {
      dispatch({ type: QMS.TEAM.UPDATE_REJECTED });
      logError(e);
    }
  },
  remove: (qmsTeamId, divisionId) => async (dispatch) => {
    dispatch({ type: QMS.TEAM.REMOVE });
    const apiEndpoint = BASE_URL + "/api/qms/QmsTeam/" + qmsTeamId;
    try {
      const res = await axios.delete(apiEndpoint);
      dispatch({
        type: QMS.TEAM.REMOVE_FULFILLED,
        qmsTeams: res.data,
        divisionId,
      });
    } catch (e) {
      dispatch({ type: QMS.TEAM.REMOVE_REJECTED });
      logError(e);
    }
  },
  removeRange: (qmsTeamIds, divisionId) => async (dispatch) => {
    dispatch({ type: QMS.TEAM.REMOVE });
    const apiEndpoint_delete = `${BASE_URL}/api/qms/QmsTeam`;
    try {
      const delRes = await axios.delete(apiEndpoint_delete, {
        params: { ids: qmsTeamIds || [] },
        paramsSerializer: (params) => qs.stringify(params),
      });
      if (delRes.data.message) {
        dispatch({ type: QMS.TEAM.REMOVE_REJECTED });
        // Show alert
        alert(delRes.data.message);
      } else {
        const apiEndpoint_getAll = BASE_URL + "/api/qms/QmsTeam/List/" + divisionId;
        const res = await axios.get(apiEndpoint_getAll);
        dispatch({
          type: QMS.TEAM.REMOVE_FULFILLED,
          divisionId,
          qmsTeams: res.data,
        });
      }
    } catch (e) {
      dispatch({ type: QMS.TEAM.REMOVE_REJECTED });
      logError(e);
    }
  },
  get: (qmsTeamId) => async (dispatch) => {
    dispatch({ type: QMS.TEAM.FETCH });
    const apiEndpoint = BASE_URL + "/api/qms/QmsTeam/" + qmsTeamId;
    try {
      const res = await axios.get(apiEndpoint);
      dispatch({ type: QMS.TEAM.FETCH_FULFILLED, qmsTeam: res.data });
    } catch (e) {
      dispatch({ type: QMS.TEAM.FETCH_REJECTED });
      logError(e);
    }
  },
  getAll: (divisionId) => async (dispatch) => {
    dispatch({ type: QMS.TEAM.FETCH_ALL });
    const apiEndpoint = BASE_URL + "/api/qms/QmsTeam/List/" + divisionId;
    try {
      const res = await axios.get(apiEndpoint);
      dispatch({
        type: QMS.TEAM.FETCH_ALL_FULFILLED,
        qmsTeams: res.data,
        divisionId,
      });
    } catch (e) {
      dispatch({ type: QMS.TEAM.FETCH_ALL_REJECTED });
      logError(e);
    }
  },
  getMember: (qmsTeamId, proDmsUserId) => async (dispatch) => {
    dispatch({ type: QMS.GENERIC_REQUEST });

    if (!qmsTeamId || !proDmsUserId) {
      dispatch({ type: QMS.GENERIC_REQUEST_REJECTED });
      return null;
    }
    const apiEndpoint = BASE_URL + `/api/qms/QmsTeam/Member/${qmsTeamId}/${proDmsUserId}`;
    try {
      const res = await axios.get(apiEndpoint);
      dispatch({ type: QMS.GENERIC_REQUEST_FULFILLED });
      return res.data;
    } catch (e) {
      dispatch({ type: QMS.GENERIC_REQUEST_REJECTED });
      logError(e);
    }
  },
  getMembers: (qmsTeamId) => async (dispatch) => {
    dispatch({ type: QMS.TEAM.FETCH_MEMBERS });
    if (!qmsTeamId) return null;
    const apiEndpoint = BASE_URL + "/api/qms/QmsTeam/Members/" + qmsTeamId;
    try {
      const res = await axios.get(apiEndpoint);
      dispatch({
        type: QMS.TEAM.FETCH_MEMBERS_FULFILLED,
        qmsTeamId,
        members: res.data,
      });
    } catch (e) {
      dispatch({ type: QMS.TEAM.FETCH_ALL_REJECTED });
      logError(e);
    }
  },
  nameExists: (teamName) => async (dispatch) => {
    dispatch({ type: QMS.GENERIC_REQUEST });
    const apiEndpoint = BASE_URL + "/api/qms/QmsTeam/NameExists/" + teamName;
    try {
      const res = await axios.get(apiEndpoint);
      dispatch({ type: QMS.GENERIC_REQUEST_FULFILLED });
      return res.data;
    } catch (e) {
      dispatch({ type: QMS.TEAM.FETCH_ALL_REJECTED });
      logError(e);
    }
  },
};

export default qmsTeamActions;
